export default __webpack_public_path__ + "static/media/background.608940aa.ogg";